<template>
  <v-dialog v-model="thank_you"  fullscreen scrollable transition="dialog-bottom-transition" :overlay="false">
    <v-card id="scroll_cart">
      <v-row row wrap align-center fill-height>
        <v-col cols="12" class="text-center">
          <v-card color="secondary" dark class="text-center title py-5">
            <v-row row wrap>
              <v-col cols="12" class="text-center"
                style="font-size:22px;"
                :class="`${arabic?'arFont':'enFont'}`"
              >
                {{i18n[language].thank_you}}
              </v-col>
              <v-col cols="12" class="text-center py-2">
                <v-btn color="primary" text
                  :class="`${arabic?'arFont':'enFont'}`"
                  @click="close()"
                >{{i18n[language].dismiss}}</v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-col cols="12" class="text-center">
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          </v-col>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
      phoneNumber:null,
      name:null,
      orderloading:false,
    }
  },
  methods: {
    close() {
      this.$store.state.thank_you = false
    }
  },
  watch:{
  },
  computed:{
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    products() {
      return this.$store.state.products
    },
    i18n(){
      return this.$store.state.i18n
    },
    language(){
      return this.$store.state.language
    },
    loading(){
      return this.$store.state.loading
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    currency_factor(){
      return this.$store.state.currency_factor
    },
    cart(){
      return this.$store.getters.cart
    },
    show_cart(){
      return this.$store.state.show_cart
    },
    country_code(){
      return this.$store.state.country_code
    },
    country(){
      return this.$store.state.country
    },
    cart_total(){
      return this.$store.state.cart_total
    },
    cart_delivery_fees(){
      return this.$store.state.cart_delivery_fees
    },
    customer(){
      return this.$store.state.customer
    },
    location(){
      return this.$store.state.location
    },
    comapny_code(){
      return this.$store.state.comapny_code
    },
    thank_you(){
      return this.$store.state.thank_you
    },
  },
  created(){
  }
}
</script>
